import type { TweetCreateRequestMediaItem } from './tweetCreateRequestMediaItem';
import type { TweetCreateRequestPoll } from './tweetCreateRequestPoll';
import type { TweetCreateRequestTweetType } from './tweetCreateRequestTweetType';

export interface TweetCreateRequest {
  media?: TweetCreateRequestMediaItem[];
  /** @nullable */
  poll?: TweetCreateRequestPoll;
  /**
   * Required for REPLY and QUOTE types
   * @nullable
   */
  referenceTweetId?: string | null;
  /**
   * Tweet text content
   * @maxLength 280
   * @nullable
   */
  text?: string | null;
  /** @nullable */
  tweetType?: TweetCreateRequestTweetType;
}
